import {
  LookupCnpjParamsSchema,
  LookupCnpjResponseSchema,
  type LookupCnpjParams,
  type LookupCnpjResponse,
} from '../../customer/company-lookup.schemas.js';

/** Same snapshot as customer Receita lookup — platform operator surface. */
export const PlatformLookupCnpjParamsSchema = LookupCnpjParamsSchema;
export const PlatformLookupCnpjResponseSchema = LookupCnpjResponseSchema;

export type PlatformLookupCnpjParams = LookupCnpjParams;
export type PlatformLookupCnpjResponse = LookupCnpjResponse;
